import type { Cart, CartItemInput } from './storefront.types';
import {
  addToCart,
  createCart,
  getCart,
  updateCartLines,
} from './storefrontClient';

type CreateUpdateCart = {
  cart: Cart;
  cartId: string;
};

const createNewCart = async (
  item: CartItemInput
): Promise<CreateUpdateCart | null> => {
  const newCart = await createCart([item]);
  if (newCart) {
    return { cart: newCart as Cart, cartId: newCart.id };
  } else {
    console.error(
      'Error creating cart, the returned cart is null or undefined'
    );
    return null;
  }
};

const updateItem = async (
  existingCart: Cart,
  item: CartItemInput,
  cartId: string
) => {
  const existingLine = existingCart.lines.edges.find(
    (line) => line.node.merchandise.id === item.merchandiseId
  );
  let updatedCart: Cart | null | undefined;
  if (existingLine) {
    const updatedQuantity = existingLine.node.quantity + item.quantity;
    updatedCart = await updateCartLines(cartId, [
      { id: existingLine.node.id, quantity: updatedQuantity },
    ]);
  } else {
    updatedCart = await addToCart(cartId, [item]);
  }
  if (updatedCart) {
    return { cart: updatedCart, cartId };
  } else {
    console.error('Existing Cart could not be updated');
    return { cart: existingCart, cartId };
  }
};

export async function updateCart(
  cartId: string | null,
  item: CartItemInput
): Promise<CreateUpdateCart | null> {
  if (!cartId) {
    return createNewCart(item);
  } else {
    let existingCart: Cart | null | undefined;

    try {
      existingCart = await getCart(cartId);

      if (existingCart && isStaleCart(existingCart.updatedAt)) {
        const refreshedCart = createNewCart(item);
        if (refreshedCart) {
          return refreshedCart;
        }
      }
    } catch {
      const newCartOnError = createNewCart(item);
      if (newCartOnError) {
        return newCartOnError;
      }
    }

    if (existingCart) {
      return updateItem(existingCart, item, cartId);
    } else {
      console.error('Could create new cart or update existing Cart');
      return null;
    }
  }
}

export function quickCheckout(variantGid: string, quantity: number): void {
  const variantId = variantGid?.split('/').pop() || '';
  window.location.href = `https://shop.sunrun.com/cart/${variantId}:${quantity}`;
}

export const isStaleCart = (updatedAt: string): boolean => {
  const ONE_DAY_IN_MS = 1000 * 60 * 60 * 24;

  const updateTime = new Date(updatedAt).getTime();
  const currentTime = Date.now();

  const ageMs = currentTime - updateTime;
  return ageMs >= ONE_DAY_IN_MS;
};
